import React, { useEffect } from 'react';
import { exportToExcel } from 'src/utils/Common';
import { BottomNavigationAction, Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';

function ExcelExport({ JsonData, ButtonType, ButtonText }) {
  const { t } = useTranslation('overview');
  if (!JsonData || JsonData.length == 0) {
    return (
      <>
        {
          ButtonType === 1 ?
            <BottomNavigationAction
              disabled={true}
              showLabel
              label={t('lblExport')}
              icon={<CloudDownloadIcon style={{ color: '#AAC8A7' }} fontSize="large" />}
            />
            : ButtonType === 2 ?
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={true}
                startIcon={<CloudDownloadOutlinedIcon />}
              >
                {t('lblExport')}
              </Button>
              : ButtonType === 3 ?
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={true}
                  endIcon={<CloudDownloadIcon />}
                >
                  {t('lblDetailedExport')}
                </Button> :
                ButtonType === 4 ?
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={true}
                    endIcon={<CloudDownloadIcon />}
                  >
                    {t('lblExport')}
                  </Button> :
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={true}
                    startIcon={<CloudDownloadOutlinedIcon />}
                  >
                    {t('lblExport')}
                  </Button>
        }
      </>
    )
  }

  return (
    // <ExcelFile
    //   element={ButtonType === 1 ? <BottomNavigationAction showLabel label={t('lblExport')} icon={<CloudDownloadIcon style={{color:'#1E5128'}} fontSize="large"/>} />
    //     : ButtonType === 2 ?
    //       <Button
    //         variant="contained"
    //         color="primary"
    //         size="small"
    //         startIcon={<CloudDownloadOutlinedIcon />}
    //       >
    //         {t('lblExport')}
    //       </Button>
    //       : ButtonType === 3 ?
    //         <Button
    //           size="small"
    //           variant="contained"
    //           color="primary"
    //           fullWidth
    //           endIcon={<CloudDownloadIcon />}
    //         >
    //           {t('lblDetailedExport')}
    //         </Button> :
    //         ButtonType === 4 ?
    //         <Button
    //           size="small"
    //           variant="contained"
    //           color="primary"
    //           fullWidth
    //           endIcon={<CloudDownloadIcon />}
    //         >
    //           {t('lblExport')}
    //         </Button> :
    //         ButtonType === 5 ?
    //         <Button
    //           size="small"
    //           variant="contained"
    //           color="primary"
    //           fullWidth
    //           endIcon={<CloudDownloadIcon />}
    //         >
    //           {t(ButtonText)}
    //         </Button> :
    //         <Button
    //           variant="contained"
    //           color="primary"
    //           startIcon={<CloudDownloadOutlinedIcon />}
    //         >
    //           {t('lblExport')}
    //         </Button>
    //   }>

    //   <ExcelSheet data={JsonData} name="Report">
    //     {
    //       JsonData[0] && Object.keys(JsonData[0]).map((value, index) => (
    //         <ExcelColumn label={t(value) !== value ? t(value) : t('lbl' + value) } value={value} />
    //       ))
    //     }
    //   </ExcelSheet>

    // </ExcelFile>
    <>
      {
        ButtonType === 1 ?
          <BottomNavigationAction
            showLabel label={t('lblExport')}
            icon={<CloudDownloadIcon
              style={{ color: '#1E5128' }}
              fontSize="large" />}

            onClick={() => exportToExcel(JsonData, 'ExportedData')}
          />
          : ButtonType === 2 ?
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<CloudDownloadOutlinedIcon />}
              onClick={() => exportToExcel(JsonData, 'ExportedData')}
            >
              {t('lblExport')}
            </Button>
            : ButtonType === 3 ?
              <Button
                size="small"
                variant="contained"
                color="primary"
                fullWidth
                endIcon={<CloudDownloadIcon />}
                onClick={() => exportToExcel(JsonData, 'ExportedData')}
              >
                {t('lblDetailedExport')}
              </Button> :
              ButtonType === 4 ?
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<CloudDownloadIcon />}
                  onClick={() => exportToExcel(JsonData, 'ExportedData')}
                >
                  {t('lblExport')}
                </Button> :
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownloadOutlinedIcon />}
                  onClick={() => exportToExcel(JsonData, 'ExportedData')}
                >
                  {t('lblExport')}
                </Button>

      }
    </>
  );
}

ExcelExport.propTypes = {

};

export default ExcelExport;
